module.exports = __webpack_public_path__ + "img/8.87c9409c.jpg";